import Phaser from 'phaser';
import { CONFIG } from '../config.js';
import { ENEMY_TEXTURES } from '../systems/PlaceholderTextures.js';

const C = CONFIG.COLORS;

export class Enemy extends Phaser.Physics.Arcade.Sprite {
  constructor(scene, x, y, type, opts = {}) {
    const tex = ENEMY_TEXTURES[type] || `enemy-${type}`;
    super(scene, x, y, tex);
    scene.add.existing(this);
    scene.physics.add.existing(this);

    const stats = CONFIG.ENEMY_TYPES[type] || CONFIG.ENEMY_TYPES.slime;
    this.enemyType = type;
    this.maxHp = opts.hp || stats.hp;
    this.hp = this.maxHp;
    this.damage = opts.damage || stats.damage;
    this.baseSpeed = opts.speed || stats.speed;
    this.speedMult = opts.speedMult || 1;
    this.setScale(opts.scaleOverride || CONFIG.ENEMY_DISPLAY_SCALE);

    const hitR = this.width * 0.2;
    this.body.setCircle(hitR, this.width / 2 - hitR, this.height / 2 - hitR);

    this.lastHitAt = 0;
    this.isMinion = !!opts.isMinion;
    this.isActiveTarget = false;
    this.question = null;

    this.activeRing = scene.add
      .circle(x, y, this.displayWidth * 0.7, 0xfde047, 0)
      .setStrokeStyle(3, C.OUTLINE_ACTIVE, 0)
      .setDepth(this.depth - 1);

    this.verbText = scene.add
      .text(x, y - this.displayHeight * 0.7, '', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '11px',
        color: '#ffffff',
        stroke: '#0f0d2c',
        strokeThickness: 4,
      })
      .setOrigin(0.5)
      .setDepth(50);
  }

  setQuestion(question) {
    this.question = question;
    if (question) this.verbText.setText(question.verbBase);
  }

  setActiveTarget(active) {
    if (this.isActiveTarget === active) return;
    this.isActiveTarget = active;
    if (active) {
      this.activeRing.setStrokeStyle(3, C.OUTLINE_ACTIVE, 1);
      this.activeRingTween = this.scene.tweens.add({
        targets: this.activeRing,
        scale: { from: 1, to: 1.25 },
        alpha: { from: 1, to: 0.45 },
        duration: 600,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut',
      });
      this.verbText.setColor('#fde047');
    } else {
      if (this.activeRingTween) {
        this.activeRingTween.stop();
        this.activeRingTween = null;
      }
      this.activeRing.setStrokeStyle(3, C.OUTLINE_ACTIVE, 0);
      this.activeRing.setScale(1).setAlpha(1);
      this.verbText.setColor('#ffffff');
    }
  }

  takeDamage(amount) {
    this.hp = Math.max(0, this.hp - amount);
    this.setTintFill(0xffffff);
    this.scene.time.delayedCall(60, () => {
      if (this.active) this.clearTint();
    });
    return this.hp <= 0;
  }

  preUpdate(time, delta) {
    super.preUpdate(time, delta);
    const player = this.scene.player;
    if (player && player.alive) {
      this.scene.physics.moveToObject(this, player, this.baseSpeed * this.speedMult);
    } else {
      this.body.setVelocity(0, 0);
    }
    this.activeRing.setPosition(this.x, this.y);
    this.verbText.setPosition(this.x, this.y - this.displayHeight * 0.65 - 8);
  }

  destroy(fromScene) {
    if (this.activeRing) this.activeRing.destroy();
    if (this.verbText) this.verbText.destroy();
    if (this.activeRingTween) this.activeRingTween.stop();
    super.destroy(fromScene);
  }
}
